import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export function ErrorRetry({ message = 'Unable to load content at the moment.', onRetry }) {
  return (
    <div className="card border border-red-500/20 bg-red-500/5 p-6 rounded-xl text-center my-4">
      <div className="flex justify-center mb-3">
        <div className="w-10 h-10 rounded-full bg-red-500/10 flex items-center justify-center text-red-400">
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </div>
      </div>
      <p className="text-sm text-gray-light mb-4">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold bg-gold/10 text-gold border border-gold/30 hover:bg-gold hover:text-black transition-all cursor-pointer"
        >
          <FontAwesomeIcon icon={faRotateRight} />
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
}
